export default props => ({
    // Default Theme...
    font: `500 ${props.theme.type.type6} ${props.theme.font.default}`,
    fontMobile: `500 ${props.theme.type.type2} ${props.theme.font.default}`,

    // Override with custom theme
    ...props.theme?.core?.pageHeading
  });
